/* unplugin-vue-components disabled */import { render } from "./Withdraw.vue?vue&type=template&id=1fc36990"
import script from "./Withdraw.vue?vue&type=script&lang=js"
export * from "./Withdraw.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__